export const withComponents = <T, V extends Record<string, unknown>,>(baseComponent: T, components: V) => {
  for (const [componentName, component] of Object.entries(components)) {
    baseComponent[componentName] = component;
  }

  return baseComponent as T & {
    [K in keyof V]: V[K]
  };
}